import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { OnboardingUser } from '../models/onboarding/on-boarding-user.model';
import { TenantConfigSearch } from '../models/onboarding/tenant-config-search.model';
import { TenantConfig } from '../models/onboarding/tenant-config.model';
/*import { UserFileNote } from '../models/onboarding/user-file-note.model';*/
import { AuthService } from '../services/auth.service';
import { ApiClientService } from './common/api-client.service';
import { State } from '../models/state.model';
import { DocumentType } from '../models/onboarding/document-type.model';
import { OnboardingUserSearch } from '../models/onboarding/on-boarding-user-search.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { map } from 'rxjs';
import { UserFile } from '../models/onboarding/user-file.model';
import { UserFileSearch } from '../models/onboarding/user-file-search.model';
import { VerifyOnboardingUserRequest } from '../models/onboarding/verifyOnboardUserRequest.model';
import { ContactModel } from '../models/packages/contact.model';
import { BackgroundQuestionDetail } from '../models/background-question-detail.model';
import { UserNotes } from '../models/onboarding/user-notes.model';
import { UserFileStatus } from '../models/onboarding/user-file-status.model';
import { NonUnifomBGQuestion, NonUniformQuestionDetail } from '../models/NonUnifomBGQuestion.model';
import { SystemDefaultDocumentChecklist } from 'models/defaultDocumentChecklist.model';
import { UserInternalNoteInsertData, UserInternalNotes } from '../models/onboarding/user-internal-notes.model';
import { RequiredDocumentConfig } from '../models/onboarding/required-document-config.model';

export interface SidebarCount {
  userInternalNotesCount: number;
}

@Injectable({
  providedIn: 'root'
})
export class BranchOnBoardingService {

  constructor(
    private apiClient: ApiClientService,
    private authService: AuthService,
    private http: HttpClient) { }


  private configSubject = new BehaviorSubject<RequiredDocumentConfig | null>(null);

  configSub = this.configSubject.asObservable();

  setRequiredDocumentData(config: RequiredDocumentConfig): void {
    this.configSubject.next(config);
  }

  getTenantFileConfig(searchParams: TenantConfigSearch, showLoading = true): Observable<TenantConfig[]> {
    return this.apiClient.post(`api/BranchOnboarding/getTenantFileConfig`, searchParams, null, showLoading);
  }

  getOnboardedUsers(searchParams: OnboardingUserSearch): Observable<OnboardingUser[]> {
    return this.apiClient.post(`api/BranchOnboarding/getOnboardingBranches`, searchParams);
  }

  insertTenantFileConfig(tenantConfigs: TenantConfig[]): Observable<any> {
    const formData = new FormData();
    formData.append('tenantConfigsJson', JSON.stringify(tenantConfigs));

    tenantConfigs.forEach((config) => {
      if (config.file) {
        formData.append('files', config.file, config.file.name);
      }
    });

    const headers = new HttpHeaders().append(
      "Content-Disposition",
      "multipart/form-data"
    );

    return this.http.post(environment.baseUrl + `api/BranchOnboarding/insertTenantFileConfig`, formData, {
      headers: headers,
      reportProgress: true
    });
  }

  uploadUserFile(userFiles: UserFile[]): Observable<any> {
    if (!userFiles.every(config=> config.file instanceof Blob)) {
      throw new Error('One or more files are not valid.');
    }

    const formData = new FormData();
    formData.append('userFileJson', JSON.stringify(userFiles));

    userFiles.forEach((config) => {
      if (config.file) {
        if (config.file instanceof Blob) {
          formData.append('files', config.file, config.file.name);
        }
      }
    });

    const headers = new HttpHeaders().append(
      "Content-Disposition",
      "multipart/form-data"
    );

    return this.http.post(environment.baseUrl + `api/BranchOnboarding/uploadBranchFiles`, formData, {
      headers: headers,
      reportProgress: true
    });
  }

  updateTenatFileConfig(tenantConfig: TenantConfig): Observable<any> {
    return this.apiClient.post(`api/BranchOnboarding/updateTenatFileConfig`, tenantConfig);
  }

  updateOnboardingUserMemo(user: OnboardingUser): Observable<any> {
    return this.apiClient.post(`api/BranchOnboarding/updateOnboardingBranchMemo`, user);
  }

  declineOnboardingUser(user: OnboardingUser): Observable<any> {
    return this.apiClient.post(`api/BranchOnboarding/declineOnboardingBranch`, user);
  }

    onboardingStatusUpdate(user: OnboardingUser): Observable<any> {
    return this.apiClient.post(`api/BranchOnboarding/onboardingStatusUpdate`, user);
  }

  insertOnboardingUser(onboardingUsers: OnboardingUser): Observable<OnboardingUser[]> {
    return this.apiClient.post(`api/BranchOnboarding/insertOnboardingBranch`, onboardingUsers);
  }

  inviteAgainAndSendEmail(onboardingUsers: OnboardingUser): Observable<OnboardingUser> {
    return this.apiClient.post(`api/BranchOnboarding/inviteAgainAndSendEmail`, onboardingUsers);
  }


  emailIsUsedOrNot(onboardingUsers: OnboardingUser): Observable<boolean> {
    return this.apiClient.post(`api/BranchOnboarding/emailIsUsed`, onboardingUsers);
  }

  insertOnboardingUserWithNpn(onboardingUser: OnboardingUser): Observable<any> {
    return this.apiClient.post(`api/BranchOnboarding/InsertMGAAgencyLicenseAndAppointmentData`, onboardingUser);
  }

  insertLicenseAndAppointmentData(onboardingUser: OnboardingUser): Observable<any> {
    return this.apiClient.post(`api/BranchOnboarding/InsertLicenseAndAppointmentData`, onboardingUser);
  } 

  InsertFirmLicenseAndAppointmentData(onboardingUser: OnboardingUser): Observable<any> {
    return this.apiClient.post(`api/BranchOnboarding/InsertFirmLicenseAndAppointmentData`, onboardingUser);
  }

    InsertFirmLicenseAndAppointmentDataAndSaveInDraft(onboardingUser: OnboardingUser): Observable<any> {
    return this.apiClient.post(`api/BranchOnboarding/InsertFirmLicenseAndAppointmentDataAndSaveInDraft`, onboardingUser);
  }

   retrievePDB(requestObject: any) {
    return this.apiClient.post(`api/BranchOnboarding/retrievePDB`, requestObject, null, true);
  }

  insertUserNotes(userNotes: UserNotes): Observable<any> {
    return this.apiClient.post(`api/BranchOnboarding/insertBranchNotes`, userNotes, null, false);
  }

  getUserNotes(userId: number): Observable<UserNotes[]> {
    return this.apiClient.get(`api/BranchOnboarding/getBranchNotes/${userId}`, null, null, false);
  }

  getStates(): Observable<State[]> {
    return this.apiClient.get(`api/BranchOnboarding/getStates`, null, null, false);
  }

    getSystemDefaultDocumentChecklist(): Observable<SystemDefaultDocumentChecklist[]> {
    return this.apiClient.get(`api/BranchOnboarding/getSystemDefaultDocumentChecklist`, null, null, false);
  }

  getDocumentTypes(): Observable<DocumentType[]> {
    return this.apiClient.get(`api/BranchOnboarding/getDocumentTypes`,  null, null, false);
  }

  getUserFiles(userFileSearch: UserFileSearch, showLoading = true): Observable<UserFile[]> {
    return this.apiClient.post(`api/BranchOnboarding/getBranchFiles`, userFileSearch, null, showLoading);
  }

 insertChecklist(
  userFileSearch: any,
  showLoading = true
): Observable<any> {
  const headers = new HttpHeaders().append(
      "Content-Disposition",
      "multipart/form-data"
    );

    return this.http.post(environment.baseUrl + `api/BranchOnboarding/insertChecklistConfigNew`, userFileSearch, {
      headers: headers
    });
}

  insertRequestedChecklist(userFileSearch: any, showLoading = true): Observable<number> {
    return this.apiClient.post(`api/BranchOnboarding/insertRequestedChecklist`, userFileSearch, null, showLoading);
  }

  sendVerificationCode(activateUrl: string) {
    var onboardingUser = {} as OnboardingUser;
    onboardingUser.activateUrl = activateUrl;
    return this.apiClient.post(`api/BranchOnboarding/sendVerificationCode`, onboardingUser, null, true);
  }

  verifyOnboardUser(verifyRequest: VerifyOnboardingUserRequest) {
    //return this.apiClient.post(`api/onboardingUser/verifyOnboardingUser`, verifyRequest, null, true);
    return this.apiClient.post(`api/BranchOnboarding/verifyOnboardingBranch`, verifyRequest, null, true);
  }

  setPwd(setPwdObj: any) {
    return this.apiClient.post(`api/BranchOnboarding/setpassword`, setPwdObj, null, true);
  }


  public downloadOnboardingFile(formId: number, userId: number) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/octet-stream',
      })
    };

    var requestUrl = environment.baseUrl + `api/BranchOnboarding/downloadOnboardingFile/${formId}/${userId}`;

    return this.http.get(requestUrl, httpOptions)
      .pipe(map((response: any) => {
        let data = response;
        return data;
      }
      ));
  }

  


  public downloadConfigFile(tenantFileConfigId: number) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/octet-stream',
      })
    };

    var requestUrl = environment.baseUrl + `api/BranchOnboarding/downloadTenantConfigFile/${tenantFileConfigId}`;

    return this.http.get(requestUrl, httpOptions)
      .pipe(map((response: any) => {
        let data = response;
        return data;
      }
      ));
  }


  public downloadTenantCheckListFile(tenantFileConfigId: number) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/octet-stream',
      })
    };

    var requestUrl = environment.baseUrl + `api/BranchOnboarding/downloadTenantCheckListFile/${tenantFileConfigId}`;

    return this.http.get(requestUrl, httpOptions)
      .pipe(map((response: any) => {
        let data = response;
        return data;
      }
      ));
  }


  public downloadCheckListTemplateFile(tenantFileConfigId: number) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/octet-stream',
      })
    };

    var requestUrl = environment.baseUrl + `api/BranchOnboarding/downloadCheckListTemplateFile/${tenantFileConfigId}`;

    return this.http.get(requestUrl, httpOptions)
      .pipe(map((response: any) => {
        let data = response;
        return data;
      }
      ));
  }

  public downloadUserFile(userFileId: number) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/octet-stream',
      })
    };

    var requestUrl = environment.baseUrl + `api/BranchOnboarding/downloadBranchFile/${userFileId}`;

    return this.http.get(requestUrl, httpOptions)
      .pipe(map((response: any) => {
        let data = response;
        return data;
      }
      ));
  }

 



  archiveUserFile(userFileId: number, admin: boolean = true): Observable<any> {
    if (admin) {
      return this.apiClient.post(`api/BranchOnboarding/archiveBranchFile/${userFileId}`, null);
    }
    else {
      //return this.apiClient.post(`api/onboardingUser/archiveUserFile/${userFileId}`, null);
      return this.apiClient.post(`api/BranchOnboarding/archiveBranchFile/${userFileId}`, null);

    }
  }


   archiveDocumentCheckList(userFileId: number, admin: boolean = true): Observable<any> {
      return this.apiClient.post(`api/BranchOnboarding/archiveBranchDocumentChecklist/${userFileId}`, null);
  }

  unarchiveUserFile(userFileId: number, admin: boolean = true): Observable<any> {
    if (admin) {
      return this.apiClient.post(`api/BranchOnboarding/unarchiveBranchFile/${userFileId}`, null);
    }
    else {
      return this.apiClient.post(`api/BranchOnboarding/unarchiveBranchFile/${userFileId}`, null);
      //return this.apiClient.post(`api/onboardingUser/unarchiveUserFile/${userFileId}`, null);

    }
  }

    unarchiveUserDocumentChecklist(userFileId: number, admin: boolean = true): Observable<any> {
      return this.apiClient.post(`api/BranchOnboarding/unarchiveBranchDocumentChecklist/${userFileId}`, null);
  }
  deleteUserFile(userFileId: number): Observable<any> {
    return this.apiClient.post(`api/BranchOnboarding/deleteBranchFile/${userFileId}`, null);
  }

   deleteUserCheckListFile(userFileId: number): Observable<any> {
    return this.apiClient.post(`api/BranchOnboarding/deleteBranchCheckListFile/${userFileId}`, null, null, false);
  }

   updateUserCheckListFileStatus(userFileId: number , statusid:number): Observable<any> {
    return this.apiClient.post(`api/BranchOnboarding/updateBranchCheckListFileStatus/${userFileId}/${statusid}`, null);
  }

  hireOnboardingUser(contact: ContactModel) {
    return this.apiClient.post(`api/BranchOnboarding/hireOnboardingBranch`, contact, null, true);
  }
  updateWithOutNPNUser(contact: ContactModel) {
    return this.apiClient.post(`api/BranchOnboarding/updateWithOutNPNBranch`, contact, null, true);
  }
  updateOnboardingUserFileStatus(userFile: UserFile) {
    return this.apiClient.post(`api/BranchOnboarding/updateOnboardingBranchFileStatus`, userFile, null, false);
  }

  updateUserSignature(user: OnboardingUser): Observable<any> {
    return this.apiClient.post(`api/BranchOnboarding/updateBranchSignature`, user);
  }

  downloadAll(userId: number , showArchived: boolean = false) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      responseType: 'blob' as 'json',
    };

    var requestUrl = environment.baseUrl + `api/BranchOnboarding/downloadAllBranchFiles/${userId}`;
    if (showArchived != null) {
      requestUrl += `/${showArchived}`;
    }
    return this.http.get(requestUrl, httpOptions)
      .pipe(map((response: any) => {
        let data = response;
        return data;
      }
      ));
  }

  updateUserEmail(user: OnboardingUser): Observable<any> {
    return this.apiClient.post(`api/BranchOnboarding/updateBranchEmail`, user);
  }

  insertUpdateUserBGQuestionDetails(backgroundQuestionDetails: BackgroundQuestionDetail[]): Observable<any> {
    return this.apiClient.post(`api/BranchOnboarding/insertUpdateBranchBGQuestionDetails`, backgroundQuestionDetails, null, false);
  }

  getUserBGQuestionDetails(userId: number, showloading: boolean = true): Observable<BackgroundQuestionDetail[]> {
    return this.apiClient.get(`api/BranchOnboarding/getBranchBGQuestionDetails/${userId}`, null, null, showloading);
  }

  getLatestBGQuestionUpdatedDate(userId: number): Observable<any> {
    return this.apiClient.get(`api/BranchOnboarding/GetLatestBGQuestionUpdatedDate/${userId}`, null, null, false);
  }

  resndUserInvitation(user: OnboardingUser): Observable<any> {
    return this.apiClient.post(`api/BranchOnboarding/resendBranchInvitation`, user);
  }

  getUserProfileInfo(userId: number): Observable<ContactModel> {
    return this.apiClient.get(`api/contact/getUserProfileInfo/${userId}`);
  }

  updateOnboardingUserFileMemo(userFile: UserFile) {
    return this.apiClient.post(`api/BranchOnboarding/updateOnboardingBranchFileMemo`, userFile, null, true);
  }

  verifyOnboardingUserEmailExist(email: string) {
    var user = { email: email } as OnboardingUser;

    return this.apiClient.post(`api/BranchOnboarding/verifyOnboardingBranchEmailExist`, user, null, true);
  }

  

  updateUserNotesTracking(userNotes: UserNotes , showLoading :boolean=true): Observable<any> {
    return this.apiClient.post(`api/BranchOnboarding/updateBranchNotesTracking`, userNotes ,null,showLoading);
  }

  getOnboardingUserChatCount(userId: number, showLoading = true): Observable<OnboardingUser[]> {
    return this.apiClient.get(`api/BranchOnboarding/getOnboardingBranchChatCount/${userId}`, null, null, showLoading);
  }

  getisBackgroundQuestionsSubmit(userId: number, showLoading = true): Observable<OnboardingUser[]> {
    return this.apiClient.get(`api/BranchOnboarding/isBackgroundQuestionsSubmit/${userId}`,null, null, showLoading);
  }

  getisEmploymentHistorySubmit(userId: number, showLoading = true): Observable<OnboardingUser[]> {
    return this.apiClient.get(`api/BranchOnboarding/isEmploymentHistorySubmit/${userId}`,null, null, showLoading);
  }

  getUserFileStatuses(isOnboardedUser: boolean, showLoading = true): Observable<UserFileStatus[]> {
    if (isOnboardedUser) {
      //return this.apiClient.get(`api/onboardingUser/getUserFileStatuses`,null, null, showLoading);
      return this.apiClient.get(`api/BranchOnboarding/getBranchFileStatuses`,null, null, showLoading);

    }
    else {
      return this.apiClient.get(`api/BranchOnboarding/getBranchFileStatuses`,null, null, showLoading);
    }
  }

  updateOnboardingUserMismatchName(user: OnboardingUser): Observable<any> {
    return this.apiClient.post(`api/BranchOnboarding/updateOnboardingBranchMismatchName`, user);
  }

   getActivitybyUserId(userId: number ,showLoading = true): Observable<any> {
    return this.apiClient.get(`api/BranchOnboarding/getActivitybyUserId/${userId}` , null,null, showLoading);
  }

  public getUserRegulatoryActionsByUserId(userId: number, sortDir: number, showLoading = true) {
    return this.apiClient.get(`api/BranchOnboarding/getUserRegulatoryActionListByUserId/${userId}/${sortDir}`, null, null, showLoading);
  }

  getOnboardingUserPDBDetails(userId: number): Observable<any>{
    return this.apiClient.get(`api/BranchOnboarding/getOnboardingUserPDBDetails/${userId}`, null, null, false);
  }

  updateOnboardingUserStates(onboardingUser: OnboardingUser): Observable<number> {
    return this.apiClient.post(`api/BranchOnboarding/updateOnboardingBranchStates`, onboardingUser);
  }

 

  updateOnboardingUserStatesAndFiles(onboardingUser: OnboardingUser): Observable<number> {
    return this.apiClient.post(`api/BranchOnboarding/updateOnboardingBranchStatesAndFiles`, onboardingUser);
  }
  GetUserNonUniformBGQuestionDetails(userId: number, showLoading: boolean = true): Observable<NonUniformQuestionDetail[]> {
    return this.apiClient.get(`api/BranchOnboarding/GetBranchNonUniformBGQuestionDetails/${userId}`, null, null, showLoading);
  }
  insertUpdateUserNonUniformBGQuestionDetails(questions: NonUnifomBGQuestion[]) {
    return this.apiClient.post(`api/BranchOnboarding/InsertUpdateBranchNonUniformBGQuestionDetails`, questions, null, false);
  }

  getUserInternalNotes(userId: number): Observable<UserInternalNotes[]> {
    return this.apiClient.get(`api/BranchOnboarding/getBranchInternalNotes/${userId}`, null, null, false);
  }

  insertUserInternalNote(payload: UserInternalNoteInsertData): Observable<number> {
    return this.apiClient.post(`api/BranchOnboarding/insertBranchInternalNote`, payload, null, false);
  }

  private userInternalNotesCounts = new BehaviorSubject<Record<number, SidebarCount>>({});
  userInternalNotesCounts$ = this.userInternalNotesCounts.asObservable();

  setUserInternalNotesCount(onboardingUsersId: number, count: number) {
    const current = this.userInternalNotesCounts.getValue();
    this.userInternalNotesCounts.next({
      ...current,
      [onboardingUsersId]: {
        userInternalNotesCount: count
      }
    });
  }

  getTenantRequiredFieldBranchFlags(userId: number, tenantId: number) {
    return this.apiClient.get(`api/BranchOnboarding/getTenantRequiredFieldBranchFlags/${userId}/${tenantId}`, null, null, false);
  }

  updateBranchFEIN(fein: string) {
    return this.apiClient.post(`api/BranchOnboarding/updateBranchFEIN/${fein}`, null, null, false);
  }
}
